import _ from 'lodash'
import {beginingLabel, cookingLabel, packagingLabel, finishedLabel} from './archetype'

let onCreateItem = [
    'duracion_preparacion_min',
    'duracion_coccion_min',
    'duracion_abatimiento_min',
    'imagen',
    'created',
    'modified',
]
let onPreparation = [
    'encabezados_id',
    'imagen',
    // 'porciones',
    // 'duracion_preparacion_min',
    // 'duracion_coccion_min',
    // 'duracion_abatimiento_min',
    // 'created',
    // 'modified',
];
let onCooking = [
    'usuario_id_responsable'
];
let onPackaging = [
    // 'porciones'
];
let onFinishing = [
    // 'porciones'
];

let hideSingleField = (obj, hideCollection) => {
    if(_.isPlainObject(obj) && hideCollection.indexOf(obj.key) != -1){
        obj.readonly = true
    }
    // console.log('hideSingleField', obj, hideCollection)
    return obj;
}

let handleFields = (fields, currentStatus) => {
    let hideCollection = [];

    switch(currentStatus) {
        case beginingLabel:
            hideCollection = _.clone(onPreparation)
            break;
        case cookingLabel:
            hideCollection = _.concat(onPreparation, onCooking)
            break;
        case packagingLabel:
            hideCollection = _.concat(onPreparation, onCooking, onPackaging)
            break;
        case finishedLabel:
            hideCollection = _.concat(onPreparation, onCooking, onPackaging, onFinishing)
            break;
        default:
            hideCollection = _.clone(onCreateItem)
            break;
    }

    return _.map(_.cloneDeep(fields), (item) => {
        if(_.isArray(item)){
            _.map(item, subItem => {
                hideSingleField(subItem, hideCollection)
                return subItem;
            })
        } else if(!_.isNull(item)) {
            hideSingleField(item, hideCollection)
        }

        return item
    })
}

export {
    handleFields
}